<template>
  <div class="about">
    <section>
      <SectionHeader title="Enquiry form"></SectionHeader>
      <div class='common__section-body'>
        <EnquiryForm class='enruiry-form__form-container'></EnquiryForm>
      </div>
    </section>
  </div>
</template>
<style>
.enruiry-form__form-container {
  max-width: 720px;
  margin: 10px auto;
}
</style>
<script>
import SectionHeader from '@/components/sectionHeader.vue'
import EnquiryForm from '@/components/enquiryForm.vue'

export default {
  name: 'enquire',
  components: {
    SectionHeader,
    EnquiryForm
  },
  data: () => ({
    clients: [
      { src: require('../assets/images/clients/client1.png') },
      { src: require('../assets/images/clients/client2.png') },
      { src: require('../assets/images/clients/client3.png') },
      { src: require('../assets/images/clients/client4.png') },
      { src: require('../assets/images/clients/client5.png') },
      { src: require('../assets/images/clients/client6.png') }
    ]
  })
}
</script>